export const FINANCE_REPORTS_DEPOSITS_STATISTICS = 'FINANCE_REPORTS_DEPOSITS_STATISTICS'
export const FINANCE_REPORTS_DEPOSITS_STATISTICS_SUCCESS = 'FINANCE_REPORTS_DEPOSITS_STATISTICS_SUCCESS'
export const FINANCE_REPORTS_DEPOSITS_STATISTICS_FAILED = 'FINANCE_REPORTS_DEPOSITS_STATISTICS_FAILED'

export const CLEAR_FINANCE_REPORTS_DEPOSITS_STATISTICS = 'CLEAR_FINANCE_REPORTS_DEPOSITS_STATISTICS'
